import { useTranslation } from 'react-i18next'

import { GlobeHemisphereEastIcon, GlobeIcon, ListIcon } from '@phosphor-icons/react'

import { ButtonGroup, Card, CardTitle } from '@reveni-io/reveni-ui'

import { viewInfoTypes } from '../constants'
import MotionContainer from '../MotionContainer/MotionContainer'
import CountriesInfo from './CountriesInfo/CountriesInfo'
import OrderBySelector from './OrderBySelector/OrderBySelector'
import Statistics from './Statistics/Statistics'
import WorldMap from './WorldMap/WorldMap'
import * as Styles from './styles'

const CountriesCard = ({
  viewType,
  onChangeViewType,
  orderBy,
  onChangeOrderBy,
  onChangeCountry,
  countryCodeSelected,
  heatMapMetrics,
  currency,
  generalMetrics,
  fetchingGeneralMetrics,
  fetchingRegions,
  regions,
  infoType,
  fetchingCountriesMetrics,
  countriesMetrics,
}) => {
  const { t } = useTranslation()

  return (
    <Card showBorder={false}>
      <CardTitle>
        <Styles.CardTitleContainer>
          <GlobeIcon />
          {t('Información de países')}
        </Styles.CardTitleContainer>
        <ButtonGroup
          buttons={[
            {
              id: viewInfoTypes.map,
              Icon: GlobeHemisphereEastIcon,
              label: t('Mapa'),
              iconWeightOnActive: 'fill',
              onClick: () => onChangeViewType(viewInfoTypes.map),
            },
            {
              id: viewInfoTypes.list,
              Icon: ListIcon,
              label: t('Lista'),
              iconWeightOnActive: 'bold',
              onClick: () => onChangeViewType(viewInfoTypes.list),
            },
          ]}
          active={viewType}
        />
      </CardTitle>
      {viewType === viewInfoTypes.map && (
        <MotionContainer>
          <Styles.ControlsContainer>
            <OrderBySelector orderBy={orderBy} onChange={onChangeOrderBy} />
          </Styles.ControlsContainer>
          <Styles.WorldMapContainer>
            <WorldMap
              onSelectCountry={onChangeCountry}
              selectedCountry={countryCodeSelected}
              heatMapMetrics={heatMapMetrics?.heatMapMetrics}
              quintiles={heatMapMetrics?.quintiles}
              orderBy={orderBy}
              currency={currency}
            />
            <Statistics
              selectedCountry={countryCodeSelected}
              metrics={generalMetrics}
              loading={fetchingGeneralMetrics || fetchingRegions}
              regions={regions}
              currency={currency}
              infoType={infoType}
            />
          </Styles.WorldMapContainer>
        </MotionContainer>
      )}
      {viewType === viewInfoTypes.list && (
        <MotionContainer>
          <CountriesInfo
            loading={fetchingCountriesMetrics}
            countries={countriesMetrics}
            regions={regions}
            onClickInCountry={onChangeCountry}
          />
        </MotionContainer>
      )}
    </Card>
  )
}

export default CountriesCard
